import { TenantFilterValue } from '@hakimo-ui/hakimo/types';
import { selectHelpers, useUser } from '@hakimo-ui/hakimo/util';
import MultiSelectFilter from '../multi-select-filter/MultiSelectFilter';

interface Props {
  value: TenantFilterValue;
  label: string;
  enableNegativeFilters?: boolean;
  onChange: (value: TenantFilterValue) => void;
  useVisionTenants?: boolean;
}

export function TenantFilter(props: Props) {
  const {
    value,
    label,
    enableNegativeFilters = false,
    onChange,
    useVisionTenants = false,
  } = props;
  const user = useUser();
  const options = useVisionTenants
    ? user.visionTenants ?? []
    : user.mspTenants ?? [];
  const getTenantsByName = (query: string) => {
    return Promise.resolve(
      options.filter((option) => selectHelpers.filterPredicate(query, option))
    );
  };

  return (
    <MultiSelectFilter
      value={value}
      label={label}
      enableNegativeFilters={enableNegativeFilters}
      onChange={onChange}
      getOptions={getTenantsByName}
    />
  );
}

export default TenantFilter;
